
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";

export const useCredits = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { data: credits = 0, isLoading } = useQuery({
    queryKey: ["credits", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("user_credits")
        .select("credits")
        .eq("user_id", user?.id)
        .single();

      if (error) throw error;
      return data.credits;
    },
    enabled: !!user,
  });

  const updateCredits = useMutation({
    mutationFn: async (newCredits: number) => {
      const { error } = await supabase
        .from("user_credits")
        .update({ credits: newCredits })
        .eq("user_id", user?.id);

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["credits", user?.id] });
    },
  });

  return { credits, isLoading, updateCredits };
};
